import 'keen-slider/keen-slider.min.css'
import KeenSlider from 'keen-slider'
// import { createAutoLoopPlugin } from './plugins/createAutoLoopPlugin.js'
import { createArrowNavigationPlugin } from './plugins/createArrowNavigationPlugin.js'
import { createThumbnailPlugin } from './plugins/createThumbnailPlugin.js'
import { navigationWrapper } from './utils/navigationWrapper.js'
// @TODO: WRAPPER CAN BE IN PLUGIN

const historySlider = {
  init: () => {
    if (! document.getElementById('history-slider')) {
      return null
    }

    // Prepare images
    // Images are turned off while page loads
    // Turn them on now
    const sliderImages = document.querySelectorAll('.keen-slider__slide');
    sliderImages.forEach((slide) => {
      slide.style.display = 'block';
    });

    const historySlider = new KeenSlider(
      '#history-slider .new-slider-container',
      {
        loop: true,
        defaultAnimation: {
          duration: 2000
        }
      },
      [
        // AutoLoopPlugin,
        createArrowNavigationPlugin(navigationWrapper),
      ]
    )

    historySlider.on("slideChanged", () => {
      const videos = document.querySelectorAll('#history-slider iframe.video-vimeo')
      videos.forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
    })

    return historySlider;
  }
}

const historySliderThumbs = {
  init: (slider) => {
    if (! document.getElementById('history-slider-thumbs')) {
      return null
    }

    // Prepare images
    // Images are turned off while page loads
    // Turn them on now
    const sliderImages = document.querySelectorAll('#history-slider .keen-slider__slide');
    sliderImages.forEach((slide) => {
     slide.style.display = 'block';

     // Bug in keen-slider?
     // If there are too many images, perhaps loading to slow,
     // some images keep a data-src, not a src and are not loaded
     const i = slide.querySelector('img');

     if (i) {
       const s = i.dataset.src
       if (s) {
         i.src = s
       }
     } else {

     }
    });

    const thumbSlider = new KeenSlider(
      '#history-slider-thumbs .new-slider-container',
      {
        initial: 0,
        slides: {
          perView: 4,
          spacing: 4
        },
        breakpoints: {
          '(min-width: 1000px)': {
            slides: {
              perView: 8
            }
          },
        }
      },

      [
        createThumbnailPlugin(slider),
        createArrowNavigationPlugin(navigationWrapper),
      ]
    );
  }
}

export default {
  init: () => {
    window.addEventListener("load", () => {
      const mainHistorySlider = historySlider.init()
      historySliderThumbs.init(mainHistorySlider)
    })
  }
}

